import INavigation from 'models/INavigation';

export const getPath = (navigation: INavigation, pageId: string ): string => {
  const { parents } = navigation;
  // tslint:disable-next-line:prefer-for-of
  for (let parentIdx = 0; parentIdx < parents.length; parentIdx++) {
    const parent = parents[parentIdx];
    const { id: parentId, children, slug: parentSlug } = parent;
    if (parentId === pageId) return parentSlug;

    // tslint:disable-next-line:prefer-for-of
    for (let childIdx = 0; childIdx < children.length; childIdx++) {
      const child = children[childIdx];
      const { id: childId, slug: childSlug } = child;
      if (childId === pageId) return `${parentSlug}/${childSlug}`;
    }
  }
  return '';
};